import React from 'react';
import { AppGridLayout, AppTableSearch, AppSearchItem, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction, AppGridBar } from 'qcc';
import api, { } from "api";
import ProgramEditForm from './ProgramEditForm'

export default class extends React.Component {
  state = {}
  add = async () => {
    let title = '新增POS版本';
    let formData = { force_update: 1 };
    let editForm = <ProgramEditForm mode={1} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title });
  }

  edit = async (data?: any) => {
    let title = '编辑POS版本';
    let editForm = <ProgramEditForm mode={1} formData={{ ...data }} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title });
  }



  delete = async (data?: any) => {
    if (await AppAction.deleteConfirm('您确定要删除该记录吗？')) {
      await api.posdevice.deleteProgram({ id: data.id });
      AppAction.successMsg('删除成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();

  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Right>
              <AppButton label='新增' actionCode="66201004" type='primary' action={this.add} />
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging sqlId='sql.pos.programGrid' >
            <AppTable.ColIndex />
            <AppTable.Col title='版本名称' field='version' width={100} />
            <AppTable.Col title='文件名称' field='file_name' width={120} />
            <AppTable.Col title='是否强制更新' width={120} render={(data: any, dataIndex: number) => {
              return data.force_update === 1 ? '是' : '否';
            }} />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                <AppButton type='link' label='编辑' actionCode="66201005" action={() => this.edit(data)} />
                <AppButton type='link' label='删除' actionCode="66201006" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/device/ProgramGird.tsx